import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Tabs({ tabs, active, onChange, ariaLabel }) {
    return (_jsx("div", { role: "tablist", "aria-label": ariaLabel, style: { display: 'flex', gap: 2, alignItems: 'center' }, children: tabs.map((t) => {
            const isActive = active === t.key;
            return (_jsxs("button", { role: "tab", type: "button", "aria-selected": isActive, onClick: () => onChange(t.key), style: {
                    padding: '6px 12px',
                    fontSize: 12,
                    fontWeight: 500,
                    borderRadius: 4,
                    color: isActive ? 'var(--fg-1)' : 'var(--fg-3)',
                    background: isActive ? 'var(--bg-elevated)' : 'transparent',
                    border: '1px solid ' + (isActive ? 'var(--border)' : 'transparent'),
                    fontFamily: t.mono ? 'var(--font-mono)' : 'inherit',
                }, children: [t.label, t.count !== undefined && (_jsx("span", { className: "dimtext", style: { marginLeft: 6, fontFamily: 'var(--font-mono)', fontSize: 11 }, children: t.count }))] }, t.key));
        }) }));
}
//# sourceMappingURL=Tabs.js.map